import { useQuery } from '@tanstack/react-query'
import { QualificationsQueryKeys } from '@tabeeb/modules/qualifications/requests'
import { useApi } from '@tabeeb/shared/utils/API'

const useQualificationByIds = (ids: number[]) => {
  const { certificateServiceApi } = useApi()

  const query = useQuery({
    queryKey: [QualificationsQueryKeys.QualificationsByIds, ids],
    queryFn: () => certificateServiceApi.qualifications.getByIdsAsync({ ids }),
    enabled: true,
    staleTime: 30000,
  })

  return { isLoading: query.isLoading, isSuccess: query.isSuccess, data: query.data }
}

export default useQualificationByIds
